import '.ag{position:relative;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.bm{position:absolute;}.ssr-plugin'
import '.bj{top:0px;}.ssr-plugin'
import '.hg{right:-4px;}.ssr-plugin'
import '.f1{width:1.5rem;}.ssr-plugin'
import '.f2{height:1.5rem;}.ssr-plugin'
import '.ar{border-radius:1.25rem;}.ssr-plugin'
import '.hh{background-color:var(--brand-primary);}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  isUploadPreview = false,
  onDelete,
  onCancelDelete,
}: {
  src: string
  isUploadPreview?: boolean
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="ag d ad r"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        resizeWidth={90}
        ignoreResize={isUploadPreview}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--palette-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="d ad r bm bj hg f1 f2 ar hh z"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--palette-white)" />
    </div>
  )
}
